import { useState, useEffect } from 'react'

// Avisos e confirmacoes no visual do site, no lugar de alert()/confirm() do navegador.
// Uso em qualquer tela, sem hook:
//   avisar('Erro ao salvar: ...')                 -> aviso no canto (cor deduzida do texto)
//   avisar('Lançamento salvo.', 'sucesso')         -> tipo explicito: sucesso | erro | atencao | info
//   if (!(await confirmar('Excluir este item?'))) return
// O <AvisosHost /> fica montado uma vez no App.jsx.

let host = null
let proximoId = 1

const tipoPorTexto = (msg) => {
  const t = String(msg || '').toLowerCase()
  if (/erro|falh|não foi possível|nao foi possivel|inválid|invalid/.test(t)) return 'erro'
  if (/^(selecione|informe|preencha|permita|libere|arquivo muito grande|não esqueça)/.test(t)) return 'atencao'
  if (/sucesso|salv[oa]|criad[oa]|enviad[oa]|importad[oa]|atualizad[oa]|excluíd[oa]|alterad[oa]/.test(t)) return 'sucesso'
  return 'info'
}

export function avisar(msg, tipo) {
  const aviso = { id: proximoId++, msg: String(msg ?? ''), tipo: tipo || tipoPorTexto(msg) }
  if (host) host.adicionarAviso(aviso)
  else window.alert(aviso.msg) // host ainda nao montado (nao deve acontecer)
}

export function confirmar(msg, { textoConfirmar = 'Confirmar', perigo } = {}) {
  const ehPerigo = perigo ?? /excluir|remover|desativar|desfazer/i.test(String(msg))
  if (!host) return Promise.resolve(window.confirm(msg))
  return new Promise(resolve => host.abrirConfirmacao({ msg: String(msg), textoConfirmar, perigo: ehPerigo, resolve }))
}

const CORES = {
  erro: { bg: '#BB0100', icone: '✕' },
  atencao: { bg: '#B26A00', icone: '!' },
  sucesso: { bg: '#2F6B3A', icone: '✓' },
  info: { bg: '#2F2F2E', icone: 'i' },
}

export function AvisosHost() {
  const [avisos, setAvisos] = useState([])
  const [confirmacao, setConfirmacao] = useState(null)

  useEffect(() => {
    host = {
      adicionarAviso: (a) => {
        setAvisos(prev => [...prev.slice(-3), a])
        setTimeout(() => setAvisos(prev => prev.filter(x => x.id !== a.id)), a.tipo === 'erro' ? 7000 : 4500)
      },
      abrirConfirmacao: (c) => setConfirmacao(c),
    }
    return () => { host = null }
  }, [])

  const responder = (valor) => {
    confirmacao?.resolve(valor)
    setConfirmacao(null)
  }

  useEffect(() => {
    if (!confirmacao) return
    const tecla = (e) => {
      if (e.key === 'Escape') responder(false)
      if (e.key === 'Enter') { e.preventDefault(); responder(true) }
    }
    window.addEventListener('keydown', tecla)
    return () => window.removeEventListener('keydown', tecla)
  })

  return (
    <>
      <div style={{ position: 'fixed', top: 18, right: 18, zIndex: 20000, display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 'min(420px, calc(100vw - 36px))' }}>
        {avisos.map(a => (
          <div key={a.id} role="status" onClick={() => setAvisos(prev => prev.filter(x => x.id !== a.id))} style={{
            display: 'flex', alignItems: 'flex-start', gap: 10, padding: '12px 16px', borderRadius: 10, cursor: 'pointer',
            background: CORES[a.tipo].bg, color: '#fff', fontSize: 13, fontWeight: 600, lineHeight: 1.4,
            boxShadow: '0 6px 20px rgba(0,0,0,0.2)', fontFamily: 'Manrope, sans-serif', whiteSpace: 'pre-line',
          }}>
            <span style={{ fontWeight: 800, flexShrink: 0 }}>{CORES[a.tipo].icone}</span>
            <span style={{ wordBreak: 'break-word' }}>{a.msg}</span>
          </div>
        ))}
      </div>

      {confirmacao && (
        <div onClick={() => responder(false)} style={{
          position: 'fixed', inset: 0, background: 'rgba(47,47,46,0.45)', zIndex: 20001,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: '#fff', borderRadius: 14, padding: 22, width: '100%', maxWidth: 400,
            boxShadow: '0 12px 40px rgba(0,0,0,0.25)', fontFamily: 'Manrope, sans-serif',
          }}>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: '#2F2F2E', lineHeight: 1.5, whiteSpace: 'pre-line' }}>{confirmacao.msg}</p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
              <button type="button" onClick={() => responder(false)} style={{
                padding: '9px 16px', background: '#fff', color: '#666', border: '1px solid #e5e5e5', borderRadius: 8,
                fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
              }}>Cancelar</button>
              <button type="button" autoFocus onClick={() => responder(true)} style={{
                padding: '9px 18px', background: confirmacao.perigo ? '#BB0100' : 'var(--primary)', color: '#fff', border: 'none',
                borderRadius: 8, fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
              }}>{confirmacao.textoConfirmar}</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
